import { useState, useRef, useEffect } from 'react';
import { categories } from '@/mocks/categories';

export default function HeroSection() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setDropdownOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <section className="relative h-[620px] md:h-[720px] w-full overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20artistic%20abstract%20composition%20featuring%20layered%20organic%20shapes%20in%20warm%20cream%20beige%20and%20muted%20sage%20green%20tones%2C%20delicate%20flowing%20curves%20resembling%20silk%20fabric%20draping%20across%20a%20bright%20airy%20canvas%2C%20gentle%20gradient%20with%20subtle%20textured%20grain%20throughout%2C%20modern%20minimalist%20editorial%20background%20perfectly%20suited%20for%20a%20high%20end%20fashion%20and%20lifestyle%20directory%2C%20natural%20diffused%20lighting%20creating%20a%20luminous%20ethereal%20atmosphere%2C%20elegant%20sophisticated%20fine%20art%20aesthetic%20with%20museum%20quality%20visual%20depth%2C%20clean%20serene%20and%20uplifting%20mood&width=1800&height=1200&seq=hero-bg-v2-2026&orientation=landscape"
          alt="Pandabuy.beer hero background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/50"></div>
      </div>

      {/* Hero Content */}
      <div className="relative z-10 w-full flex flex-col items-center justify-center px-4 md:px-6 pt-16 md:pt-24">
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white text-center leading-tight mb-6">
          Best Pandabuy
          <br />
          Spreadsheet 2026
        </h1>
        <p className="text-white/75 text-sm md:text-base text-center max-w-xl mb-8 leading-relaxed">
          Discover the Most Updated Pandabuy Spreadsheet for Sneakers, Clothing, Hoodies, Bags, and Popular Brands.
        </p>

        {/* Category Dropdown */}
        <div ref={dropdownRef} className="relative mb-6 w-full max-w-md">
          <button
            onClick={() => setDropdownOpen(!dropdownOpen)}
            className="w-full flex items-center justify-between bg-white/10 backdrop-blur-sm border border-white/25 rounded-lg px-4 py-3 text-white text-sm font-medium cursor-pointer hover:bg-white/15 transition-colors"
          >
            <span>{dropdownOpen ? 'Choose a category' : 'Browse Categories'}</span>
            <i className={`ri-arrow-down-s-line text-lg transition-transform duration-200 ${dropdownOpen ? 'rotate-180' : ''}`}></i>
          </button>
          {dropdownOpen && (
            <div className="absolute top-full left-0 w-full bg-white rounded-md mt-1 overflow-hidden z-30 max-h-72 overflow-y-auto">
              {categories.map((cat) => (
                <a
                  key={cat.id}
                  href={cat.href}
                  target="_blank"
                  rel="noopener nofollow"
                  className="flex items-center gap-3 px-4 py-3 text-sm text-foreground-800 hover:bg-background-100 transition-colors border-b border-background-100 last:border-b-0 whitespace-nowrap cursor-pointer"
                >
                  <i className={`${cat.icon} text-base text-primary-500`}></i>
                  {cat.name}
                </a>
              ))}
            </div>
          )}
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center gap-3 w-full max-w-md">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto flex-1 text-center bg-primary-500/80 hover:bg-primary-500 text-white font-semibold text-sm px-8 py-3 rounded-full transition-all duration-200 backdrop-blur-sm whitespace-nowrap cursor-pointer"
          >
            pandabuy sheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto flex-1 text-center border-2 border-white/60 hover:border-white hover:bg-white/10 text-white font-semibold text-sm px-8 py-3 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            buy it now
          </a>
        </div>

        {/* Social Proof Stats */}
        <div className="flex items-center gap-8 md:gap-12 mt-10">
          <div className="text-center">
            <p className="text-white text-lg md:text-2xl font-bold">20,000+</p>
            <p className="text-white/60 text-xs">Products Indexed</p>
          </div>
          <div className="text-center">
            <p className="text-white text-lg md:text-2xl font-bold">500+</p>
            <p className="text-white/60 text-xs">Updated Links</p>
          </div>
          <div className="text-center">
            <p className="text-white text-lg md:text-2xl font-bold">100+</p>
            <p className="text-white/60 text-xs">Categories</p>
          </div>
        </div>
      </div>

      {/* Bottom Brand Text */}
      <div className="absolute bottom-6 md:bottom-10 w-full text-center z-10">
        <p className="text-white/20 text-4xl md:text-6xl lg:text-8xl font-heading font-bold tracking-tighter whitespace-nowrap select-none">
          PANDABUY SHEET
        </p>
      </div>
    </section>
  );
}